export default __webpack_public_path__ + "static/Homepage-5cc607330060e4a01ec614d4dfd2024e.mp4";